import { render, staticRenderFns } from "./PCStore.vue?vue&type=template&id=70e49109&scoped=true"
import script from "./PCStore.vue?vue&type=script&lang=js"
export * from "./PCStore.vue?vue&type=script&lang=js"
import style0 from "./PCStore.vue?vue&type=style&index=0&id=70e49109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e49109",
  null
  
)

export default component.exports